<template>
  <div class="ro-login account-box">
    <div class="ro-login-title">
      {{ letter.selectLoginType }}
    </div>

    <!-- 二维码+三方登录模式 (主界面) -->
    <!-- 掃碼登錄 -->
    <div class="qrcode-login-section">
      <div class="section-title">{{ letter.v3ScanCodeLogin || '掃碼登錄' }}：</div>
      <div class="qrcode-container">
        <div class="qrcode-box">
            <img
              v-if="qrCodeUrl"
              :src="qrCodeUrl"
              alt="二維碼"
              class="qrcode-img"
            />
            <div v-if="isInitializing || qrCodeLoading" class="qrcode-loading">
              <div class="loading-icon"></div>
              <div class="qrcode-text">{{ letter.v3ScanLoading || '加載中...' }}</div>
            </div>
            <div
              v-if="qrStatus === QRCodeStatus.EXPIRED && !qrCodeLoading"
              class="qrcode-expired"
              @click="refreshQRCode"
            >
              <div class="qrcode-text">{{ letter.v3ScanExpired || '二維碼已過期' }}</div>
              <div class="qrcode-text">{{ letter.v3ScanRefreshClick || '點擊刷新' }}</div>
              <div class="qrcode-text">
                <div class="refresh-icon"></div>
                {{ letter.v3ScanRefresh || '刷新' }}
              </div>
            </div>
            <div
              v-if="qrStatus === QRCodeStatus.SCANNED"
              class="qrcode-scanned"
            >
              <div class="qrcode-text">{{ letter.v3ScanSucc || '掃碼成功' }}</div>
              <div class="qrcode-text">{{ letter.v3ScanAuth || '請在手機上確認' }}</div>
            </div>
            <div
              v-if="qrStatus === QRCodeStatus.CONFIRMED"
              class="qrcode-confirmed"
            >
              <div class="qrcode-text">{{ letter.v3ScanAuthSuccess || '授權成功' }}</div>
              <div class="qrcode-text">
                {{ letter.v3ScanAuthSuccessTip || '正在登錄...' }}
              </div>
            </div>
            <div
              v-if="qrStatus === QRCodeStatus.UNAUTHORIZED && !qrCodeLoading"
              class="qrcode-expired"
              @click="refreshQRCode"
            >
              <div class="qrcode-text">{{ letter.v3ScanUnauthorized || '已拒絕授權' }}</div>
              <div class="qrcode-text">{{ letter.v3ScanRefreshTip || '請重新掃碼' }}</div>
              <div class="qrcode-text">
                <div class="refresh-icon"></div>
                {{ letter.v3ScanRefresh || '刷新' }}
              </div>
            </div>
          </div>
          <div class="qrcode-tip">{{ letter.v3ScanRefreshTip2 || '請打開遊戲登錄後掃碼登錄' }}</div>
          <div class="qrcode-actions">
            <a href="javascript:;" class="action-link" @click="!qrCodeLoading && refreshQRCode()">
              <span class="refresh-icon-small"></span> {{ letter.v3ScanRefresh || '刷新' }}
            </a>
            <span class="divider">|</span>
            <a href="javascript:;" class="action-link scan-guide-btn">
              {{ letter.v3ScanGuide || '掃碼指引' }}
              <div class="scan-guide"></div>
            </a>
          </div>
        </div>
      </div>

    <!-- 第三方登錄 -->
    <div class="third-party-login-section">
      <div class="section-title">{{ letter.v3ThirdPartyLogin || '第三方登錄' }}：</div>
      <div class="other-login">
        <div
          v-for="(item, index) in filteredThirdList"
          :key="index"
          class="third-box j-third-part-login"
        >
          <a
            class="login-type"
            href="javascript:;"
            :class="`j-${item}-login-btn ${$platformClass}`"
            @click="loginHrefJump(loginHref[item], false)"
          >
            <i :class="item"></i>
            <p class="name">{{ channelName[item] }}</p>
          </a>
        </div>
      </div>
    </div>

    <button class="account-info j-account-info" @click="showAccountLoginPopup">
      {{ letter.v3NoMyLoginMethod || '沒有我的登錄方式？' }}
    </button>

    <!-- 账号密码登录弹窗 -->
    <transition name="fade">
      <div class="account-login-popup" v-if="showAccountPopup" @click.self="closeAccountPopup">
        <div class="popup-content">
          <div class="popup-header">
            <h3 class="popup-title">{{ letter.v3AccountPasswordLogin || '賬號密碼登錄' }}</h3>
            <a href="javascript:;" class="popup-close" @click="closeAccountPopup">
              <span class="close-icon">×</span>
            </a>
          </div>
          <div class="popup-body">
            <label class="input-box box" :class="{ err: userAccountTips }">
              <span class="label">{{ letter.accountLabel }}：</span>
              <input
                v-model="userAccount"
                class="input"
                type="text"
                :class="{ err: userAccountTips }"
                @blur="judgeUserAccount()"
                :placeholder="letter.accountName"
              />
            </label>
            <p class="tips j-username-tip" v-if="userAccountTips">
              {{ userAccountTips }}
            </p>
            <label
              class="input-box password-box box"
              :class="{ err: userPasswordTips }"
            >
              <span class="label">{{ letter.passwordLabel }}：</span>
              <input
                v-model="userPassword"
                class="input"
                type="password"
                :class="[userPasswordTips ? 'err' : false, $platformClass]"
                @blur="judgeUserPassword()"
                :placeholder="letter.password"
              />
            </label>
            <p class="tips j-password-tip" v-if="userPasswordTips">
              {{ userPasswordTips }}
            </p>
            <div class="remember box">
              <div>
                <i class="goukuang j-remember-me" @click="toggleRemember">
                  <i class="gou" v-show="isRemember"></i>
                </i>
                <span class="text j-remember-me" @click="toggleRemember">
                  {{ letter.remember }}
                </span>
              </div>

              <a
                :href="findPwd"
                target="_blank"
                class="forget j-forget-pwd"
                v-if="!musVn"
              >
                {{ letter.forgetPwd }}
              </a>
            </div>
            <div class="btn-wrap">
              <a
                href="javascript:void(0);"
                class="btn login-btn j-login-btn"
                pointClass="j-login-btn"
                :loading="loading"
                @click="login"
              >
                <span>{{ letter.login }}</span>
                <i v-show="loading" class="loading light" style="margin-left: 1vh"></i>
              </a>
              <p class="tips j-request-tip request-tip">{{ loginRequestTips }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/javascript">
import { CHANNEL_NAME } from '../../store/web/login.js';
import login from '../../mixins/Login.js';
import qrCodeLogin from '../../mixins/webLogin/qrCodeLogin.js';
import globalConfig from '../../utiles/globalConfig.js';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'accountLoginPage',
  mixins: [login, qrCodeLogin],
  data() {
    return {
      channelName: CHANNEL_NAME,
      showThirdPart: globalConfig.getHrefParam('noThridPart') !== '1',
      // 初始化时就设置为 true，确保显示加载状态
      isInitializing: true,
      // 账号密码登录弹窗显示状态
      showAccountPopup: false
    };
  },
  computed: {
    findPwd() {
      let gameId =
        this.$store.state.gameId || globalConfig.getHrefParamUndecode('gameId');
      return getGlobalGetGotoLink({
        link: `https://pay.${mainHost}/platform/passport.html?gameId=${gameId}&appLanguage=${this.$store.state.lang}&language=${this.$store.state.lang}#/findPwd`
      });
    },
    letter() {
      return this.$store.state.letter;
    },
    // 过滤三方登录列表，只保留 Facebook 和 Google
    filteredThirdList() {
      return this.thirdList.filter(item =>
        ['facebook', 'googleplay'].includes(item)
      );
    }
  },
  watch: {
    // 监听二维码URL的变化，一旦生成就关闭初始化状态
    qrCodeUrl(newVal) {
      if (newVal) {
        this.isInitializing = false;
      }
    },
    // 监听二维码状态，如果出现错误状态也关闭初始化状态
    qrStatus(newVal) {
      if (newVal === this.QRCodeStatus.EXPIRED || newVal === this.QRCodeStatus.UNAUTHORIZED) {
        this.isInitializing = false;
      }
    },
    // 监听 gameId 的变化，一旦有值就初始化二维码
    gameId(newVal) {
      if (newVal && !this.qrCodeUrl) {
        this.initQRCodeLogin();
      }
    }
  },
  mounted() {
    // gameId 已经存在，则立即初始化二维码
    // 否则等待 watch 中的 gameId 监听器触发
    if (this.gameId) {
      this.initQRCodeLogin();
    }
  },
  methods: {
    showAccountLoginPopup() {
      this.showAccountPopup = true;
    },
    closeAccountPopup() {
      this.showAccountPopup = false;
    },
    loginHrefJump(href, target) {
      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'openThirdLoginLink',
            url: href
          },
          '*'
        );
      } else {
        window.open(href, target ? '_blank' : '_self');
      }
    },
    /**
     * 二维码登录成功后的处理
     * 覆盖 qrCodeLogin mixin 的默认行为
     * 使用后端验证后返回的 forward 参数进行重定向，支持 iframe 模式
     */
    async onQRCodeLoginSuccess(res) {
      console.log('二维码登录成功', res);

      // 使用后端验证后返回的 forward（安全的跳转地址）
      const redirectUrl = res.forward || window.location.href;

      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'refreshPage',
            url: redirectUrl
          },
          '*'
        );
      } else {
        window.location.href = redirectUrl;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';
</style>
